import { useMemo } from 'react';
import { useSearchParams as _useSearchParams } from 'react-router';

export function useSearchParams() {
  const [searchParams, setSearchParams] = _useSearchParams();

  const memoizedSearchParams = useMemo(() => searchParams, [searchParams]);

  return [memoizedSearchParams, setSearchParams] as const;
}
